export default __webpack_public_path__ + "media/projects/yellow1-thumb-d6532936.svg";